import { extendObservable, runInAction } from 'mobx';

import { ServiceTrackingController } from '../../../../networking/controllers/ServiceTrackingController';
import { ApiError, ERROR_STATUSES, ERROR_CODES } from '../../../../models/ApiError';
import { Logger } from '../../../../helpers/Logger';
import { Recaptcha } from '../../../../helpers/Recaptcha';

class ServiceTrackingStoreClass {
  constructor() {
    extendObservable(this, {
      serviceTracking: null,

      loadingServiceTracking: false,
      findInternalError: false,
      findApiError: null,
      findError: false,

      updateInternalError: false,
      updateApiError: null,
      updateError: false,
    });
  }

  async findCustomerData(data) {
    runInAction(() => {
      this.loadingServiceTracking = true;
      this.findInternalError = false;
      this.findApiError = null;
      this.findError = false;
    });
    try {
      const cutomerInfo = await ServiceTrackingController.getCustomerInfo(data);
      runInAction(() => {
        this.serviceTracking = cutomerInfo;
      });
    } catch (error) {
      Logger.warn(error);
      if (ApiError.isSameTypeAs(error)) {
        if (error.status >= ERROR_STATUSES.SERVER_ERROR) {
          runInAction(() => {
            this.findInternalError = true;
          });
        } else if (error.code === ERROR_CODES.INVALID_SERVICE_INFORMATION) {
          runInAction(() => {
            this.findApiError = error.code;
          });
        } else {
          runInAction(() => {
            this.findError = true;
          });
        }
      }
    } finally {
      runInAction(() => {
        this.loadingServiceTracking = false;
      });
    }
  }

  async findServiceTracking(data) {
    runInAction(() => {
      this.loadingServiceTracking = true;
      this.findInternalError = false;
      this.findApiError = null;
      this.findError = false;
    });
    try {
      ServiceTrackingController.find(data)
        .then((res) => {
          const parseDate = (input) => {
            const regex = /(\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{2}:\d{2} [APM]{2})/;
            const match = input.match(regex);
            if (match) {
              const dateTimeStr = match[0];
              const date = new Date(dateTimeStr);
              const formattedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
              const result = input.replace(dateTimeStr, formattedDate);
              return result;
            }
            return input;
          };
          res.sections.sort((a, b) => (a.order < b.order ? -1 : 1));
          res.sections = res.sections.map((x) => {
            if (x.description && x.description.includes('Vencido este plazo perderá todo derecho al mismo')) {
              // eslint-disable-next-line no-param-reassign
              x.description = parseDate(x.description);
            }
            return x;
          });
          runInAction(() => {
            this.serviceTracking = res;
          });
        });
    } catch (error) {
      Logger.warn(error);
      if (ApiError.isSameTypeAs(error)) {
        if (error.status >= ERROR_STATUSES.SERVER_ERROR) {
          runInAction(() => {
            this.findInternalError = true;
          });
        } else if (error.code === ERROR_CODES.INVALID_SERVICE_INFORMATION) {
          runInAction(() => {
            this.findApiError = error.code;
          });
        } else {
          runInAction(() => {
            this.findError = true;
          });
        }
      }
    } finally {
      runInAction(() => {
        this.loadingServiceTracking = false;
      });
      Recaptcha.reset();
    }
  }

  async updateServiceTracking(data) {
    runInAction(() => {
      this.loadingServiceTracking = true;
      this.updateInternalError = false;
      this.updateApiError = null;
      this.updateError = false;
    });
    try {
      const serviceTracking = await ServiceTrackingController.update(data);
      serviceTracking.sections.sort((a, b) => (a.order < b.order ? -1 : 1));
      runInAction(() => {
        this.serviceTracking = serviceTracking;
      });
    } catch (error) {
      Logger.warn(error);
      if (ApiError.isSameTypeAs(error)) {
        if (error.status >= ERROR_STATUSES.SERVER_ERROR) {
          runInAction(() => {
            this.updateInternalError = true;
          });
        } else if (error.code === ERROR_CODES.INVALID_SERVICE_ACTION) {
          runInAction(() => {
            this.updateApiError = error.code;
          });
        } else {
          runInAction(() => {
            this.updateError = true;
          });
        }
      }
    } finally {
      runInAction(() => {
        this.loadingServiceTracking = false;
      });
    }
  }

  clearErrors() {
    runInAction(() => {
      this.findInternalError = false;
      this.findApiError = null;
      this.findError = false;

      this.updateInternalError = false;
      this.updateApiError = null;
      this.updateError = false;
    });
  }
}

const ServiceTrackingStore = new ServiceTrackingStoreClass();

export { ServiceTrackingStore };



// WEBPACK FOOTER //
// ./src/pages/information/service-tracking/stores/ServiceTrackingStore.js